import moment from 'moment';

// Get current timezone
export const getLocalTimeZone = () => {
    let timezone = moment?.tz?.guess();
    // moment.js uses old city name Calcutta rather then Kolkata, so we are replacing it.
    timezone = timezone?.replace("Calcutta","Kolkata");
    return timezone;
}